exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select-component[data-v-20d887b8]{width:80%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-20d887b8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/SelectColumnComponent.vue
// module id = 854
// module chunks = 2